// Integration SVG Icons - Centralized file for third-party service integration icons
// Used exclusively for CRM, HR, Email, SAML, and Calendar integration components
// All icons are wrapped with createIconComponent for consistent sizing and props

// Integration SVG Icons - Centralized file for third-party service integration icons
// Used exclusively for CRM, HR, Email, SAML, and Calendar integration components
// All icons are wrapped with createIconComponent for consistent sizing and props

import { ReactComponent as OktaIcon } from 'icons/svg/okta.svg';
import { ReactComponent as MicrosoftAzureIcon } from 'icons/svg/microsoft-azure.svg';
import { ReactComponent as SlackIcon } from 'icons/svg/slack-icon.svg';
import { ReactComponent as EventbriteIcon } from 'icons/svg/eventbrite-icon.svg';
import { ReactComponent as MondayIcon } from 'icons/svg/monday-icon.svg';
import { ReactComponent as ZohoIcon } from 'icons/svg/zoho.svg';
import { ReactComponent as HubspotIcon } from 'icons/svg/hubspot.svg';
import { ReactComponent as SalesforceIcon } from 'icons/svg/salesforce.svg';
import { ReactComponent as DynamicsIcon } from 'icons/svg/dynamics-icon.svg';
import { ReactComponent as AzureSAMLIcon } from 'icons/svg/Azure-SAML-icon.svg';

import { ReactComponent as MarketoIcon } from 'icons/svg/marketo-icon.svg';

import { ReactComponent as PardotIcon } from 'icons/svg/pardot-icon.svg';

import { ReactComponent as PipedriveIcon } from 'icons/svg/pipedrive-icon.svg';

import { ReactComponent as VinSolutionsIcon } from 'icons/svg/vinSolutions-icon.svg';

import { ReactComponent as WorkdayIcon } from 'icons/svg/workday-icon.svg';

import { ReactComponent as ZapierIcon } from 'icons/svg/zapier-icon.svg';

import { ReactComponent as ChiliPiperIcon } from 'icons/svg/chili-piper-icon.svg';

// Import Outlook icon
import { OutlookIcon } from 'icons/brandIcons';
import { GoogleIcon } from 'icons/brandIcons';

// Wrapper function to control icon size and props
const createIconComponent = (Icon) => {
  return ({ width = 32, height = 32, ...props }) => (
    <Icon
      width={width}
      height={height}
      {...props}
    />
  );
};

export const Okta = createIconComponent(OktaIcon);
export const MicrosoftAzure = createIconComponent(MicrosoftAzureIcon);
export const Slack = createIconComponent(SlackIcon);
export const Eventbrite = createIconComponent(EventbriteIcon);
export const Monday = createIconComponent(MondayIcon);
export const Zoho = createIconComponent(ZohoIcon);
export const Hubspot = createIconComponent(HubspotIcon);
export const Salesforce = createIconComponent(SalesforceIcon);
export const Dynamics = createIconComponent(DynamicsIcon);
export const AzureSAML = createIconComponent(AzureSAMLIcon);
export const Marketo = createIconComponent(MarketoIcon);
export const Pardot = createIconComponent(PardotIcon);
export const Pipedrive = createIconComponent(PipedriveIcon);
export const VinSolutions = createIconComponent(VinSolutionsIcon);
export const Workday = createIconComponent(WorkdayIcon);
export const Zapier = createIconComponent(ZapierIcon);
export const ChiliPiper = createIconComponent(ChiliPiperIcon);

// Outlook Icon
export const Outlook = createIconComponent(OutlookIcon);
export const Google = createIconComponent(GoogleIcon);